import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  sideBar: false,
};

const sidebarSlice = createSlice({
  name: "sideBar",

  initialState,
  reducers: {
    setSideBar: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.sideBar = payload;
    },
    resetSideBar: (state: any) => {
      state.sideBar = false;
    },
  },
});

export const { setSideBar, resetSideBar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
